import { render, staticRenderFns } from "./BulkUpdateInput.vue?vue&type=template&id=0b7f45aa&"
import script from "./BulkUpdateInput.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateInput.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdateInput.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports